import { render, staticRenderFns } from "./ChargeType.vue?vue&type=template&id=228a7277&scoped=true&"
import script from "./ChargeType.vue?vue&type=script&lang=js&"
export * from "./ChargeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a7277",
  null
  
)

export default component.exports